import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseConfig } from '../../../shared/service/base-config.service';
import { GenericHttpService } from '../../../shared/service/generic-http.service';
import { AlteraValorMensalDistribuicao, CadastraValorMensalDistribuicao, DadosOnInitModelView } from '../model/cadastra-valor-mensal-distribuir.model';
import { CadastraValorMensalDistribuir } from '../../valor-mensal-distribuir/cadastra-valor-mensal-distribuir.component';


@Injectable()
export class CadastrarValorMensalDistribuicaoService {

 
  constructor(
   
    private baseConfig: BaseConfig,
    private readonly http: GenericHttpService<any>) {
  }

  public dadosOnInitFormulario (): Observable<DadosOnInitModelView> {
    
    return this.http.getAny(this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/DadosOnInitFormulario'), undefined);
  }
 
  public existeValorMensalDistribuicao(item : CadastraValorMensalDistribuir ): Observable<any> {
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/ExisteValorMensalDistribuicaoRoyalty'), item);
  }

  public registrarValorMensalDistribuicao(item : CadastraValorMensalDistribuicao ): Observable<any> {    
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/RegistrarValorMensalDistribuicaoRoyalty'), item);
  }
  public  gerarRelatoriodeValoresaDistribuir(dadosCadastroValormensal:any[]): Observable<Blob>{
      const url = this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/gerarExcel');
      return this.http.reportExcel(url, dadosCadastroValormensal);
  }

  public alterarValorMensalDistribuicao(item : AlteraValorMensalDistribuicao ): Observable<any> {    
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/AlterarValorMensalDistribuicaoRoyalty'), item);
  }

  public deletarValorMensalDistribuicao(item : AlteraValorMensalDistribuicao ): Observable<any> {    
    return this.http.post(this.baseConfig.getBaseUrlApi().concat('/royalts/ValorMensalDistribuir/DeletarValorMensalDistribuicaoRoyalty'), item);
  }

}



// WEBPACK FOOTER //
// ./src/app/royalts/shared/service/cadastra-valor-mensal-distribuir..service.ts